import { IStore } from "reducers";

export const getPoiObjectId = (objectId: string, poi?: string) => {
    return [objectId, poi].filter(Boolean).join("-");
};

export const getMutate = (state: IStore) => {
    return state.mutate;
};

export const getSnapshot = (state, objectId: string, poi?: string) =>
    getMutate(state).snapshots.get(getPoiObjectId(objectId, poi));
export const getCommittedSnapshot = (state, objectId: string) => getMutate(state).committedSnapshots.get(objectId);

export const getHEAD = (state: IStore, objectId: string, poi?: string) =>
    getMutate(state).HEADs.get(getPoiObjectId(objectId, poi));
